import { EnvironmentModel } from './environment.model'

export function env(): EnvironmentModel {
  return {
    stage: 'env-demo',
    auth: {
      // Geteilter Auth0-Dev-Tenant mit env-test (Team-Entscheidung): die Demo-Stage bekommt
      // keinen eigenen Tenant, nur die zusaetzlichen Callback-/Logout-/Web-Origin-URLs an der
      // bestehenden TST-Application. Audience bleibt deshalb ebenfalls die TST-Audience —
      // sie ist ein reiner Identifier-String, keine aufgerufene URL.
      domain: 'dev-c4be3obj05th0lrq.eu.auth0.com',
      clientId: 'o3b8OICbcp3i5PTtnCytgal9OhMCjPgL',
      authorizationParams: {
        audience: 'https://tst-inko-leistungserbringer-backend.azurewebsites.net/',
        scope: 'openid profile email offline_access',
        redirect_uri: window.location.origin,
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
      httpInterceptor: {
        allowedList: ['https://demo-leistungerbringer-restbackend-d6b6ggfncfe3ccdr.germanywestcentral-01.azurewebsites.net/api/*'],
      },
    },
    api: {
      leistungserbringerUrl: 'https://demo-leistungerbringer-restbackend-d6b6ggfncfe3ccdr.germanywestcentral-01.azurewebsites.net/api',
    },
    selfserviceWebappBaseUrl: 'https://versorgung-demo.saniup.de',
  }
}
